import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData, getList } from "../../helpers/fackBackend_Helper";

function* addMDNSwapResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/addMDNSwap", data);
    if (response?.response?.data[0].Status) {
      yield put(
        actions.createMdnSwapRequestSuccessful(
          response?.response?.data[0].Message,
        ),
      );
    } else {
      yield put(
        actions.createMdnSwapRequestFailed(response?.response?.data[0].Message),
      );
    }
  } catch (error) {
    yield put(actions.createMdnSwapRequestFailed(error));
  }
}

function* getMDNSwapResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/getMDNSwapList", data);
    if (response?.response?.Status) {
      yield put(actions.getMdnSwapRequestSuccessful(response?.response?.data));
    } else {
      yield put(actions.getMdnSwapRequestFailed(response?.response?.Message));
    }
  } catch (error) {
    yield put(actions.getMdnSwapRequestFailed(error));
  }
}

function* getMDNSwapBatchTransactionIdResponse({ payload: { data } }) {
  try {
    const response = yield call(
      getList,
      `/getMDNSwapBatchData/${data.batchID}`,
    );
    if (response.response?.Status) {
      yield put(
        actions.getMdnSwapBatchTransactionIdRequestSuccessful(
          response.response.Data,
        ),
      );
    } else {
      yield put(
        actions.getMdnSwapBatchTransactionIdRequestFailed(
          response.response.Message,
        ),
      );
    }
  } catch (error) {
    yield put(actions.getMdnSwapBatchTransactionIdRequestFailed(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CREATE_MDN_SWAP_REQUEST, addMDNSwapResponse),
    takeEvery(actions.GET_MDN_SWAP_REQUEST, getMDNSwapResponse),
    takeEvery(
      actions.GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST,
      getMDNSwapBatchTransactionIdResponse,
    ),
  ]);
}
